import React, { useState, useEffect } from "react";
import "./subsolos.css";
import { getLuzesStatusFlex8 } from "../../../API/basic/FeedBackLuzes";

import Sub01 from "./paginas/subsolo01";
import Sub02 from "./paginas/subsolo02";

const Subsolo = () => {
    const [luzesStatus, setLuzesStatus] = useState([]);
    const [subSoloAtual, setSubSoloAtual] = useState("sub01");

    useEffect(() => {
        const fetchData = async () => {
            const data = await getLuzesStatusFlex8(); // Atualiza o estado com os dados recebidos
            setLuzesStatus(data);
        };

        fetchData();
        const intervalId = setInterval(fetchData, 8000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="CampoSubsolo">
            <div className="menuSubSolo">
                <button
                    className={`botaoSubSolo ${subSoloAtual === "sub01" ? "selecionado" : ""}`}
                    onClick={() => setSubSoloAtual("sub01")}
                >
                    Sub 01
                </button>
                <button
                    className={`botaoSubSolo ${subSoloAtual === "sub02" ? "selecionado" : ""}`}
                    onClick={() => setSubSoloAtual("sub02")}
                >
                    Sub 02
                </button>
            </div>
            {subSoloAtual === "sub01" && <Sub01 luzesStatus={luzesStatus} />}
            {subSoloAtual === "sub02" && <Sub02 luzesStatus={luzesStatus} />}
        </div>
    );
};

export default Subsolo;
